import React, { useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Lock } from "@mui/icons-material";
import PasswordField from "../../ui/FormFields/PasswordField";
import "../../../styles/UserStyles.css";
import CustomButton from "../../ui/FormFields/Button";
import { DASHBOARD, LOGIN, VENDOR_DASHBOARD } from "../Routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import {
  changePasswordRequest,
  resetChangePassword,
} from "../../../redux/changePassword/ChangePasswordAction";
import { ToastContainer, toast } from "react-toastify";
import LoginForm from "../../../redux/auth/components/LoginForm";
import { logoutRequest } from "../../../redux/auth/actions/authActions";
import { CUSTOMER_DASHBOARD } from "../Routes/CustomerRoutes";
export default function ChangePassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetChangePassword());
  }, []);
  const changePassword = useSelector((state) => state.changePassword || "");
  const errorMessage = changePassword?.errorMessage;
  const successMessage = changePassword?.successMessage;
  const loading = changePassword?.loading;
  const user = useSelector((state) => state.auth.user);

  console.log("errroMessage", errorMessage);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      current_password: "",
      new_password: "",
      confirm_password: "",
    },
    mode: "onChange",
  });
  useEffect(() => {
    if (successMessage) {
      toast.success("Password Changed SuccessFully", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetChangePassword());
          dispatch(logoutRequest());
          localStorage.clear();
          navigate(LOGIN);
        },
        closeOnClick: true, // Toast will disappear on click
      });
    }
  }, [successMessage]);
  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetChangePassword());
        },

        closeOnClick: true,
      });
    }
  }, [errorMessage]);

  const passwordFields = [
    {
      name: "current_password",
      label: "Current Password",
      placeholder: "Enter your current password",
      rules: { required: "Current password is required" },
      icon: <Lock />,
    },
    {
      name: "new_password",
      label: "New Password",
      placeholder: "Enter your new password",
      rules: { required: "New password is required" },
      icon: <Lock />,
    },
    {
      name: "confirm_password",
      label: "Confirm Password",
      placeholder: "Confirm your new password",
      rules: {
        required: "Please confirm your new password",
        validate: (value) =>
          value === watch("new_password") || "Passwords do not match",
      },
      icon: <Lock />,
    },
  ];

  const onSubmit = (data) => {
    console.log("Form Data Submitted:", data);

    dispatch(changePasswordRequest(data));
  };

  return (
    <Box className="change-password-container">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        closeOnClick
        draggable={false}
      />
      <Typography className="change-password-title">Change Password</Typography>

      <form
        onSubmit={handleSubmit((data) => {
          onSubmit(data);
        })}
      >
        {passwordFields.map((field) => (
          <PasswordField
            key={field.name}
            name={field.name}
            label={field.label}
            placeholder={field.placeholder}
            rules={field.rules}
            control={control}
            icon={field.icon}
          />
        ))}

        <Grid item xs={12}>
          <Box className="button-container">
            <CustomButton
              variant="contained"
              className="cancel-button"
              type="button"
              text="Back"
              onClick={() => {
                dispatch(resetChangePassword());
                let bookingsRoute;

                if (user.role === "Admin") {
                  bookingsRoute = DASHBOARD;
                } else if (user.role === "Vendor") {
                  bookingsRoute = VENDOR_DASHBOARD;
                } else if (user.role === "Customer") {
                  bookingsRoute = CUSTOMER_DASHBOARD;
                }

                navigate(bookingsRoute);
              }}
            />

            <CustomButton
              variant="contained"
              className="success-button"
              type="submit"
              loading={loading}
              text="Submit"
            />
          </Box>
        </Grid>
      </form>
    </Box>
  );
}
